import { createRouter, createWebHashHistory } from 'vue-router'

// app pages
import AdminUserAdd from '@/pages/Admin/User/Add'
import AdminUserList from '@/pages/Admin/User/List'
import AdminUserPage from '@/pages/Admin/User/Page'

import ProfileEdit from '@/pages/Profile/Edit'
import ProfilePage from '@/pages/Profile/Page'
import ChangePassword from '@/pages/Profile/ChangePassword'

import PropertyAdd from '@/pages/Property/Add'
import PropertyCompetitors from '@/pages/Property/Competitors'
import PropertyList from '@/pages/Property/List'
import PropertyPage from '@/pages/Property/Page'

import ResetPasswordPage from '@/pages/Authentication/Password/Reset'
import SetPassword from '@/pages/Authentication/Password/Set'
import LoginPage from '@/pages/Authentication/Login'

import { isEmpty } from 'lodash'
import { api } from '@/api'

const router = createRouter({
  history: createWebHashHistory(),
  routes: [
    {
      path: '/',
      redirect: '/properties'
    },
    {
      path: '/properties',
      redirect: '/properties/list'
    },
    {
      path: '/properties/list/:page(\\d+)?/:sortField?/:sortDirection?',
      name: 'PropertyList',
      component: PropertyList
    },
    {
      path: '/properties/add',
      name: 'PropertyAdd',
      component: PropertyAdd
    },
    {
      path: '/properties/edit/:id(\\d+)',
      name: 'PropertyEdit',
      component: PropertyAdd
    },
    {
      path: '/properties/copy/:id(\\d+)',
      name: 'PropertyCopy',
      component: PropertyAdd
    },
    {
      path: '/properties/view/:id(\\d+)',
      name: 'PropertyPage',
      component: PropertyPage
    },
    {
      path: '/properties/view/:id(\\d+)/competitors/:room_id(\\d+)/:deposit?/:keyMoney?',
      name: 'PropertyCompetitors',
      component: PropertyCompetitors
    },
    {
      path: '/account/profile',
      name: 'ProfilePage',
      component: ProfilePage
    },
    {
      path: '/account/profile/edit',
      name: 'ProfileEdit',
      component: ProfileEdit
    },
    {
      path: '/admin',
      redirect: '/admin/users'
    },
    {
      path: '/admin/users',
      name: 'AdminUserList',
      component: AdminUserList
    },
    {
      path: '/admin/users/add',
      name: 'AdminUserAdd',
      component: AdminUserAdd
    },
    {
      path: '/admin/users/view/:id(\\d+)',
      name: 'AdminUserPage',
      component: AdminUserPage
    },
    {
      path: '/reset_password',
      name: 'ResetPassword',
      component: ResetPasswordPage
    },
    {
      path: '/set_password',
      name: 'SetPasswordPage',
      component: SetPassword
    },
    {
      path: '/login',
      name: 'LoginPage',
      component: LoginPage
    },
    {
      path: '/account/change_password',
      name: 'ChangePassword',
      component: ChangePassword
    }
  ],
  scrollBehavior () {
    return { left: 0, top: 0 }
  }
})

const SKIP_CHECK_TOKEN_ROUTES = [
  'LoginPage',
  'SetPasswordPage',
  'ResetPassword'
]

const redirectToLoginPage = (next) => () => {
  next({ name: 'LoginPage', replace: true })
}

router.beforeEach((to, from, next) => {
  if (SKIP_CHECK_TOKEN_ROUTES.includes(to.name)) {
    return next()
  }
  if (isEmpty(localStorage.AuthToken)) {
    redirectToLoginPage(next)()
  } else {
    api.post('/sessions/check', {}, { headers: { Authorization: localStorage.AuthToken }})
      .then(() => next())
      .catch(redirectToLoginPage(next))
  }
})

// Reload once after logging in. vue-router 4 updates the URL only after the guards resolve, so this
// has to run in afterEach: reloading inside beforeEach would reload /login again and loop.
router.afterEach((to, from) => {
  if (from.name === 'LoginPage' && !SKIP_CHECK_TOKEN_ROUTES.includes(to.name)) {
    location.reload()
  }
})

export default router
